import { Topic } from "./Topic";
import { Question } from "./Question";
import { Choice } from "./Choice";
import { Result } from "./Result";

export function findTopic(topics: Topic[], topicId: string): Topic | undefined {
  return topics.find(t => t.topicID.toLowerCase() === topicId.toLowerCase());
}

export function findQuestion(
  questions: Question[],
  questionId: string
): Question | undefined {
  return questions.find(
    q => q.questionID.toLowerCase() === questionId.toLowerCase()
  );
}

export function findChoice(
  choices: Choice[],
  choiceId: string
): Choice | undefined {
  return choices.find(c => c.choiceID.toLowerCase() === choiceId.toLowerCase());
}

export function findResult(
  results: Result[],
  resultId: string
): Result | undefined {
  return results.find(c => c.resultID.toLowerCase() === resultId.toLowerCase());
}
